import * as yup from 'yup';

export const serviceTransferSchema = yup.object().shape({
  topic: yup
    .string()
    .required('O assunto é obrigatório')
    .test('not-zero', 'Selecione um assunto', value => value !== ''),
  reason: yup.string().required('O motivo é obrigatório'),
});
